import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import styled from "styled-components";

import UserApi from "../../api/user-api";

import { Button } from "components/ui-kit/styled-templates";

const RecoveryPage = (props) => {
    const { t } = useTranslation();

    let { recoveryKey } = useParams();
    const [user, setUser] = useState(undefined);
    const [loading, setLoading] = useState(false);

    const [password, setPassword] = useState("");
    const [passwordConfirmation, setPasswordConfirmation] = useState("");

    if (recoveryKey == undefined) {
        recoveryKey = props.recoveryKey;
    }

    useEffect(() => {
        if (recoveryKey == undefined || recoveryKey == "") {
            return;
        }
        setLoading(true);
        UserApi.getUserByRecoveryKey(recoveryKey)
            .then((uu) => {
                setUser(uu);
                setLoading(false);
            })
            .catch((exc) => {});
    }, [recoveryKey]);

    return (
        <FullPageWrapper>
            <InnerPlaceholder>
                <FormPlaceholder>
                    {user == undefined ? null : (
                        <>
                            <p>{`Email: ${user.email}`}</p>
                            <Row>
                                <Input
                                    placeholder={t("pp3mrz2bw8c")}
                                    value={password}
                                    onChange={(evt) => {
                                        setPassword(evt.target.value);
                                    }}
                                />
                            </Row>
                            <Row>
                                <Input
                                    placeholder={t("sbfxi4frtu")}
                                    value={passwordConfirmation}
                                    onChange={(evt) => {
                                        setPasswordConfirmation(evt.target.value);
                                    }}
                                />
                            </Row>

                            <Row
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                            >
                                <Button
                                    onClick={async () => {
                                        if (password != undefined && passwordConfirmation != password) {
                                            return window.alert(t("0r68eypi9bfc"));
                                        }
                                        if (password.length < 4) {
                                            return window.alert(t("z26ztrp35m"));
                                        }
                                        setLoading(true);
                                        await UserApi.resetPassword(recoveryKey, password);
                                        setLoading(false);
                                        window.alert(t("eac9jo4j58"));
                                        window.location.href = "/";
                                    }}
                                >
                                    {loading == true ? "..." : t("zlm18ttklo")}
                                </Button>
                            </Row>
                        </>
                    )}
                </FormPlaceholder>
            </InnerPlaceholder>
        </FullPageWrapper>
    );
};

const Input = styled.input`
    box-sizing: border-box;
    width: 100%;
    height: 40px;
`;

const Row = styled.div`
    margin-bottom: 10px;
`;

const FormPlaceholder = styled.div`
    box-sizing: border-box;
    text-align: center;
    width: 520px;
    text-align: center;
    @media (max-width: 520px) {
        width: 100%;
    }
`;

const FullPageWrapper = styled.div`
    position: fixed;
    z-index: 10;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    box-sizing: border-box;
`;

const InnerPlaceholder = styled.div`
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: white;
`;

const Wrapper = styled.div`
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 20px;
`;

export default RecoveryPage;
